import { CustomPart } from "./CustomPart";

export class CustomPartCanvas {
  constructor(dom, product) {
    this.dom = dom;
    this.customParts = [];
    this.customPartOpts = [];
    this.addShadowSrc = product.addShadow;
    this.dpr = window.devicePixelRatio || 1;
    this.canvas = document.createElement("canvas");
    this.canvas.width = this.dom.width * this.dpr;
    this.canvas.height = this.dom.height * this.dpr;
    this.ctx = this.canvas.getContext("2d");
    this.ctx.scale(this.dpr, this.dpr);
    this.dom.append(this.canvas);
    for (let part of product.productParts) {
      this.customParts.push(new CustomPart(part));
    }
    for (let part of product.productPartOpts) {
      this.customPartOpts.push(new CustomPart(part));
    }
    window.addEventListener("resize", () => this.resize());
  }

  async init() {
    await this.load();
    let sampleImage = this.customParts[0].originalFrontImage;
    this.sampleImageWidth = sampleImage.width;
    this.hwRatio = sampleImage.height / sampleImage.width;
    this.dom.style.paddingBottom = `${this.hwRatio * 100}%`;
    this.resize();
    this.draw();
  }
  updatePartMask(partUID, customPart){
    let part = this.customParts.find((element) => element.uid == partUID);
    if (!part) {
      console.error(`Part with UID ${partUID} not found.`);
      return;
    }
    part.originalFrontImage = customPart.originalFrontImage;
    if(customPart.customShadow){
      console.log(customPart.customShadow);
      this.addShadowImg = customPart.customShadow;
    }
  }
  updatePart(partUID, texture) {
    let part = this.customParts.find((element) => element.uid == partUID);
    // console.log(texture);
     if (!part) {
      console.error(`Part with UID ${partUID} not found.`);
      return;
    }
    if (part.backImage != undefined && part.type != "stitch") {
      let maskedLayerBack = getMaskedLayer(
        part.originalBackImage,
        texture.backImage,
        this.width,
        this.height
      );
      part.setBackImage(maskedLayerBack);
    }
    let maskedLayerFront = getMaskedLayer(
      part.originalFrontImage,
      texture.frontImage,
      this.width,
      this.height
    );
    part.setFrontImage(maskedLayerFront);
    this.draw();
  }

  highlightPart(partUID) {
    // console.log(part);
    let ctx = this.ctx;
    ctx.clearRect(0, 0, this.width, this.height);
    for (let part of this.customParts) {
      if (part.backImage) {
        part.draw(ctx, part.backImage, 0, 0, this.width, this.height);
        if (partUID == part.uid) {
          let highlightedBack = getHighlightedLayer(
            part.backImage,
            this.width,
            this.height
          );
          part.draw(ctx, highlightedBack, 0, 0, this.width, this.height);
        }
      }
      part.draw(ctx, part.frontImage, 0, 0, this.width, this.height);
      if (partUID == part.uid) {
        let highlightedFront = getHighlightedLayer(
          part.frontImage,
          this.width,
          this.height
        );
        part.draw(ctx, highlightedFront, 0, 0, this.width, this.height);
      }
    }
    if (this.stampingPreview) {
      this.stampingPreview.draw();
    }
    if (this.addShadowImg) {
      this.drawAdditionalShadow();
    }
  }

  previewPart(partUID, texture) {
    let ctx = this.ctx;
    ctx.clearRect(0, 0, this.width, this.height);
    for (let part of this.customParts) {
      if (partUID == part.uid) {
        if (part.backImage != undefined && part.type != "stitch") {
          let maskedLayerBack = getMaskedLayer(
            part.originalBackImage,
            texture.backImage,
            this.width,
            this.height
          );
          part.draw(ctx, maskedLayerBack, 0, 0, this.width, this.height);
        } else if (part.type == "stitch") {
          part.draw(ctx, part.backImage, 0, 0, this.width, this.height);
        }
        let maskedLayerFront = getMaskedLayer(
          part.originalFrontImage,
          texture.frontImage,
          this.width,
          this.height
        );
        part.draw(ctx, maskedLayerFront, 0, 0, this.width, this.height);
      } else {
        if (part.backImage != undefined) {
          part.draw(ctx, part.backImage, 0, 0, this.width, this.height);
        }
        part.draw(ctx, part.frontImage, 0, 0, this.width, this.height);
      }
    }
    if (this.stampingPreview) {
      this.stampingPreview.draw();
    }
    if (this.addShadowImg) {
      this.drawAdditionalShadow();
    }
  }
  drawAdditionalShadow() {
    this.ctx.save();
    this.ctx.globalCompositeOperation = "multiply";
    this.ctx.drawImage(this.addShadowImg, 0, 0, this.width, this.height);
    this.ctx.restore();
  }
  attachStampingPreview(previewInstance) {
    this.stampingPreview = previewInstance;
    this.stampingPreview.draw();
  }

  async load() {
    for (let part of this.customParts) {
      if (!part.loaded) {
        await part.load();
      }
    }
    for (let part of this.customPartOpts) {
      if (!part.loaded) {
        await part.load();
      }
    }
    if (this.addShadowSrc) {
      const img = new Image();
      img.crossOrigin = 'Anonymous'
      img.src = this.addShadowSrc;
      await img.decode();
      this.addShadowImg = img;
    }
  }

  draw() {
    let ctx = this.ctx;
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0,0, this.width, this.height);
    // ctx.clearRect(0, 0, this.width, this.height);
    for (let part of this.customParts) {
      if (part.backImage) {
        part.draw(ctx, part.backImage, 0, 0, this.width, this.height);
      }
      part.draw(ctx, part.frontImage, 0, 0, this.width, this.height);
    }
    if (this.stampingPreview) {
      this.stampingPreview.draw();
    }
    if (this.addShadowImg) {
      this.drawAdditionalShadow();
    }
  }

  resize() {
    let domRect = this.dom.getBoundingClientRect();
    this.scale = domRect.width / this.sampleImageWidth;
    this.canvas.width = domRect.width * this.dpr;
    this.canvas.height = domRect.height * this.dpr;
    this.canvas.style.width = domRect.width + "px";
    this.canvas.style.height = domRect.height + "px";
    this.width = domRect.width * this.dpr;
    this.height = domRect.height * this.dpr;
    this.draw();
  }
}

function getMaskedLayer(sourceImage, maskImage, cWidth, cHeight) {
  let hiddenCanvas = document.createElement("canvas");
  let ctx = hiddenCanvas.getContext("2d");
  let dpr = window.devicePixelRatio || 1;
  ctx.scale(dpr, dpr);
  hiddenCanvas.width = cWidth;
  hiddenCanvas.height = cHeight;
  ctx.drawImage(sourceImage, 0, 0, cWidth, cHeight);
  ctx.globalCompositeOperation = "source-in";
  // ctx.drawImage(maskImage, 0, 0, cWidth, cHeight);
  let pattern = ctx.createPattern(maskImage, "repeat");
  let matrix = new DOMMatrix();
  pattern.setTransform(matrix.scale(dpr));
  ctx.rect(0, 0, cWidth, cHeight);
  ctx.fillStyle = pattern;
  ctx.fill();

  // document.body.append(hiddenCanvas);
  return hiddenCanvas;
}

function getHighlightedLayer(sourceImage, cWidth, cHeight) {
  let hiddenCanvas = document.createElement("canvas");
  let ctx = hiddenCanvas.getContext("2d");
  let dpr = window.devicePixelRatio || 1;
  ctx.scale(dpr, dpr);
  hiddenCanvas.width = cWidth;
  hiddenCanvas.height = cHeight;
  ctx.drawImage(sourceImage, 0, 0, cWidth, cHeight);
  ctx.globalCompositeOperation = "source-in";
  ctx.fillStyle = "rgba(255, 255, 255, 0.3)";
  ctx.fillRect(0, 0, cWidth, cHeight);

  // document.body.append(hiddenCanvas);
  return hiddenCanvas;
}
